module.exports = "/_next/static/images/remont-9a71581bf228c5c82fb1f4c7184e2b12.svg";